import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';

// const AnyReactComponent = ({text}) => <img src="http://maps.google.com/mapfiles/ms/icons/red-dot.png"/>;

const handleApiLoaded = (map, maps, places) => {
    const markers = [];
    const infowindows = [];
    places.forEach((farmer) => {
        markers.push(new maps.Marker({
            position: {
                lat: parseFloat(farmer.farmlatlong.split(",")[0]),
                lng: parseFloat(farmer.farmlatlong.split(",")[1]),
            },
            map,
        }));

        infowindows.push(new maps.InfoWindow({
            content:

            "<div>Name:" +
            farmer.name + " " + farmer.surname +
            "<br/>Phone:" +
            farmer.phone +
            "<br/>Email:" +
            farmer.email+
            "<br/>Address:" +
            farmer.address+
            "<br/>" +
            "</div>",
        }));
    });

    markers.forEach((marker, i) => {
        marker.addListener('click', () => {
            infowindows[i].open(map, marker);
        });
    });
};


class Map extends Component {
    static defaultProps = {
        center: {
            lat: -26.185453,
            lng: 28.034301
        },
        zoom: 7
    };

    constructor(props) {
        super(props)
        console.log(props);

    }
    getMapOptions = (maps) => {

        return {
            streetViewControl: false,
            scaleControl: true,
            fullscreenControl: false,
            styles: [{
                featureType: "poi.business",
                elementType: "labels",
                stylers: [{
                    visibility: "off"
                }]
            }],
            gestureHandling: "greedy",
            disableDoubleClickZoom: true,
            minZoom: 6,

            mapTypeControl: true,
            mapTypeId: maps.MapTypeId.SATELLITE,
            mapTypeControlOptions: {
                style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: maps.ControlPosition.BOTTOM_CENTER,
                mapTypeIds: [
                    maps.MapTypeId.ROADMAP,
                    maps.MapTypeId.SATELLITE,
                    maps.MapTypeId.HYBRID
                ]
            },

            zoomControl: true,
            clickableIcons: false
        };
    }


    render() {
        return (
            // Important! Always set the container height explicitly
            <div style={{height: '70vh', width: '100%',marginTop:"20vh"}}>
                <GoogleMapReact

                    bootstrapURLKeys={{key: 'AIzaSyAqjBK8fP6gSGZS9oocUYv-bDM-b88cOoo'}}
                    defaultCenter={this.props.center}
                    defaultZoom={this.props.zoom}
                    onGoogleApiLoaded={({map, maps}) => handleApiLoaded(map, maps, this.props.data)}
                    options={this.getMapOptions}
                >
                    {/*{this.props.data && this.props.data.map((farmer, i) =>*/}
                    {/*<AnyReactComponent*/}
                    {/*lat={farmer.farmlatlong.split(",")[0]}*/}
                    {/*lng={farmer.farmlatlong.split(",")[1]}*/}
                    {/*text="My Marker"*/}
                    {/*/>*/}

                    {/*)}*/}

                </GoogleMapReact>
            </div>
        );
    }
}

export default Map;


// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/Map.js